<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs11 class="offset-half">
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-folder-alert-outline</v-icon
              >
            </v-card>
            <div class="usuario">PENDIENTES</div>
            <!-- Botón de actualizar manual -->
            <v-btn
              color="#1D3C7F"
              @click="obtenerCasos"
              class="ml-5 update-btn"
              style="color: white; font-weight: bold"
              :loading="loadingObtenerCasos"
              :disabled="loadingObtenerCasos"
            >
              <template v-if="!loadingObtenerCasos">
                <v-icon size="28px">mdi-refresh</v-icon>
              </template>
              <template v-else>
                <v-progress-circular
                  indeterminate
                  color="white"
                  size="24"
                ></v-progress-circular>
              </template>
            </v-btn>
            <v-spacer></v-spacer>

            <!-- Filtro por empresa (solo para Mesa de Servicios y Sistemas) -->
            <div v-if="mostrarFiltroEmpresa" class="filter-container mr-3">
              <v-select
                v-model="filtroEmpresa"
                :items="opcionesEmpresa"
                item-text="text"
                item-value="value"
                label="Filtrar por empresa"
                outlined
                dense
                style="max-width: 180px; font-size: 13.5px"
                @change="aplicarFiltroEmpresa"
              ></v-select>
            </div>

            <!-- 🟢 NUEVO: Filtro específico para Gestión Humana (solo si el usuario es de Facilisimo y área 3) -->
            <div v-if="idAreaUsuario === 3 && idEmpresaUsuario === 1" class="filter-container mr-3">
              <v-select
                v-model="filtroGestionHumana"
                :items="opcionesGestionHumana"
                item-text="text"
                item-value="value"
                label="Filtrar por"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="aplicarFiltroGestionHumana"
              ></v-select>
            </div>

            <!-- Filtro para cambiar vista -->
            <div class="filter-container">
              <!-- Select normal para pantallas grandes -->
              <v-select
                v-if="!$vuetify.breakpoint.xs"
                v-model="selectedFilter"
                :items="filterOptions"
                item-text="text"
                item-value="value"
                label="Cambiar vista"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="changeFilter"
              ></v-select>

              <!-- Solo icono para pantallas pequeñas -->
              <v-menu
                v-if="$vuetify.breakpoint.xs"
                v-model="showFilterMenu"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="filter-icon-btn">
                    <v-icon>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in filterOptions"
                    :key="option.value"
                    @click="selectFilterOption(option.value)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>

          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar caso pendiente"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="casosFiltrados"
            :search="search"
            v-model="casosSeleccionados"
            show-select
            item-key="cc_id_caso"
            style="border: 2px solid #111c3d"
            class="elevation-3"
            must-sort
          >
            <template v-slot:footer.prepend>
              <v-btn
                v-if="mostrarBotonAsignarMasivo"
                color="#1D3C7F"
                class="asignar-masivo-btn"
                :disabled="casosSeleccionados.length < 2"
                @click="abrirConfirmacionAsignacionMasiva"
                style="color: whitesmoke; font-weight: bold"
                large
              >
                <v-icon left style="color: whitesmoke"
                  >mdi-account-multiple-plus</v-icon
                >
                ASIGNAR SELECCIONADOS
              </v-btn>
              <v-btn
                color="#1D3C7F"
                class="acciones-masivas-btn ml-2"
                :disabled="!puedeRealizarAccionMasiva"
                @click="abrirModalAccionMasiva"
                style="color: whitesmoke; font-weight: bold"
                large
              >
                <v-icon left style="color: whitesmoke"
                  >mdi-playlist-edit</v-icon
                >
                ACCIONES MASIVAS
                <v-tooltip
                  bottom
                  v-if="
                    !puedeRealizarAccionMasiva && casosSeleccionados.length > 0
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon right small v-bind="attrs" v-on="on"
                      >mdi-information</v-icon
                    >
                  </template>
                  <span
                    >No se pueden combinar casos con estados diferentes</span
                  >
                </v-tooltip>
              </v-btn>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.semaforo`]="{ item }">
              <SemaforoTiempo
                :fechaInicio="item.fecha_area"
                :dias="requerimientosInfo[item.cc_id_requerimiento]?.dias || 0"
                :horas="
                  requerimientosInfo[item.cc_id_requerimiento]?.horas || 0
                "
                :minutos="
                  requerimientosInfo[item.cc_id_requerimiento]?.minutos || 0
                "
                :idCaso="item.cc_id_caso"
                :tiempoRestanteBackend="item.tiempoRestanteBackend"
                :tiempoAcumulado="item.tiempo_acumulado"
                :fechaSuspension="item.fecha_suspension"
                :estadoCaso="item.estado_caso"
                :areaId="item.cc_id_area_requerimiento"
                :diasFestivos="diasFestivos"
                @caso-vencido="handleCasoVencido"
              />
            </template>
            <template v-slot:[`item.cc_prioridad_requerimiento`]="{ item }">
              <div v-if="item.cc_prioridad_requerimiento === '3'">
                <v-chip outlined class="ma-2" :color="item.color">
                  ALTA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '2'">
                <v-chip outlined class="ma-2" :color="item.color">
                  MEDIA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '1'">
                <v-chip outlined class="ma-2" :color="item.color">
                  BAJA
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.cc_id_asesor`]="{ item }">
              <v-icon color="primary" @click="handleAsesor(item.infoAsesor)">
                mdi-account-tie
              </v-icon>
              <v-icon color="purple" @click="verHistorial(item)" class="ml-1">
                mdi-timeline-clock
              </v-icon>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                v-if="item.nombre_especialista == 'SIN ASIGNAR'"
                color="green"
                class="mr-2"
                @click="asignarCaso(item)"
              >
                mdi-clipboard-check-outline
              </v-icon>

              <v-icon color="blue" class="mr-2" @click="verConversacion(item)">
                mdi-eye
              </v-icon>

              <v-icon
                v-if="item.nombre_especialista == nombre"
                color="red"
                class="mr-2"
                @click="cerrarCaso(item)"
              >
                mdi-folder-remove-outline
              </v-icon>
              <v-icon
                v-if="item.nombre_especialista == nombre"
                color="green"
                class="mr-2"
                @click="cambiarEstado(item)"
              >
                mdi-cog-clockwise
              </v-icon>
              <!-- ✅ BOTÓN DE ESCALAR CORREGIDO -->
              <v-icon
                  v-if="item.id_especialista == 0 || item.nombre_especialista == 'SIN ASIGNAR'"
                  color="red"
                  class="mr-2"
                  @click="escalar(item)"
              >
                  mdi-elevator-up
              </v-icon>
              <v-icon
                color="orange"
                class="mr-2"
                @click="abrirAgregarObservacion(item)"
              >
                mdi-comment-plus
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <v-dialog
            v-model="dialogConfirmarAsignacionMasiva"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-clipboard-check-outline</v-icon>
                  Asignar caso
                </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-card-text style="font-size: 18px; color: black">
                    ¿Está seguro que desea asignarse estos casos?
                  </v-card-text>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="dialogConfirmarAsignacionMasiva = false"
                  >NO</v-btn
                >
                <v-btn color="#1D3C7F" dark @click="confirmarAsignacionMasiva"
                  >SI</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para asignación masiva de líderes -->
          <v-dialog
            v-model="dialogAsignacionMasivaLider"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-account-multiple-plus</v-icon>
                  Asignar casos a especialista
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-autocomplete
                    class="mt-4"
                    v-model="especialistaSeleccionadoMasivo"
                    :items="items"
                    item-text="nombre"
                    item-value="idUsuario"
                    filled
                    label="Seleccione el especialista"
                    :rules="[(v) => !!v || 'Debe seleccionar un especialista']"
                  ></v-autocomplete>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeAsignacionMasivaLider"
                  >CANCELAR</v-btn
                >
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="confirmarAsignacionMasivaLider"
                  :disabled="!especialistaSeleccionadoMasivo"
                  >ASIGNAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal de acciones masivas -->
          <v-dialog v-model="dialogAccionMasiva" max-width="600px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-playlist-edit</v-icon>
                  Acción masiva sobre casos seleccionados
                </span>
              </v-card-title>
              <v-card-text>
                <div class="acciones-masivas-list">
                  <v-btn
                    v-for="accion in accionesDisponiblesSegunEstado"
                    :key="accion.key"
                    :color="accion.color"
                    class="accion-masiva-opcion"
                    :class="{
                      'accion-masiva-opcion--active':
                        accionSeleccionada === accion.key,
                    }"
                    @click="seleccionarAccionMasiva(accion.key)"
                    large
                  >
                    <v-icon left>{{ accion.icon }}</v-icon>
                    {{ accion.label }}
                  </v-btn>
                  <div
                    v-if="accionesDisponiblesSegunEstado.length === 0"
                    class="text-center pa-4"
                  >
                    <v-alert type="warning" outlined>
                      No hay acciones masivas disponibles para los casos
                      seleccionados.
                      <br />
                      <small
                        >Selecciona casos con el mismo estado para ver las
                        acciones disponibles.</small
                      >
                    </v-alert>
                  </div>
                </div>
                <div v-if="accionSeleccionada">
                  <div
                    v-if="
                      accionSeleccionada === 'asignar' &&
                      mostrarConfirmacionAsignacion
                    "
                  >
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Está seguro que desea asignarse estos casos?
                    </p>
                  </div>
                  <div v-else-if="accionSeleccionada === 'desasignar'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Está seguro que desea desasignar estos casos?
                    </p>
                  </div>
                  <div v-else-if="accionSeleccionada === 'reasignar'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿A qué especialista desea reasignar estos casos?
                    </p>
                    <v-select
                      v-model="especialistaSeleccionado"
                      :items="especialistasDisponibles"
                      item-text="nombre"
                      item-value="idUsuario"
                      label="Seleccionar especialista"
                      outlined
                      class="mt-4"
                      :loading="cargandoEspecialistas"
                      :disabled="cargandoEspecialistas"
                    ></v-select>
                    <v-text-field
                      v-model="observacionReasignacion"
                      label="Observación de reasignación"
                      outlined
                      class="mt-4"
                    ></v-text-field>
                  </div>
                  <div v-else-if="accionSeleccionada === 'cerrar'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Está seguro que desea cerrar estos casos?
                    </p>
                    <v-text-field
                      v-model="masivoObservaciones"
                      label="Observaciones"
                      outlined
                      class="mt-4"
                      :rules="observacionesRules"
                      required
                    />
                    <!-- INICIO componente del modal agregar varios archivos -->
                    <div
                      id="drop-area"
                      @dragover.prevent
                      @dragenter.prevent
                      @drop.prevent="handleDropMultiple"
                      @paste.prevent="handlePasteMultiple"
                      style="margin-top: 16px"
                    >
                      <div v-if="previewImages.length">
                        <div
                          v-for="(img, idx) in previewImages"
                          :key="idx"
                          style="margin-bottom: 8px"
                        >
                          <img
                            :src="img"
                            alt="Vista previa"
                            style="
                              max-width: 100px;
                              max-height: 100px;
                              display: block;
                              margin: 0 auto;
                            "
                          />
                        </div>
                      </div>
                      <div v-if="selectedFiles.length">
                        <div
                          v-for="(file, idx) in selectedFiles"
                          :key="idx"
                          style="margin-bottom: 8px"
                        >
                          <v-icon color="primary" v-if="!isImageFile(file)"
                            >mdi-file</v-icon
                          >
                          <span>{{ file.name }}</span>
                        </div>
                      </div>
                      <span
                        v-if="!previewImages.length && !selectedFiles.length"
                      >
                        Arrastra y suelta o copia y pega archivos aquí (Word,
                        Excel, PDF, imágenes)
                      </span>
                    </div>
                    <input
                      type="file"
                      ref="fileInput"
                      @change="handleFileChangeMultiple"
                      style="display: none"
                      multiple
                      accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.zip,.rar"
                    />
                    <button
                      @click="openFileInput"
                      class="upload-button"
                      style="margin-top: 8px"
                    >
                      Seleccionar Archivos
                    </button>
                    <!-- FIN componente del modal agregar varios archivos -->
                  </div>
                  <div v-else-if="accionSeleccionada === 'suspender'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Por qué desea suspender estos casos?
                    </p>
                    <v-text-field
                      v-model="masivoMotivo"
                      label="Motivo"
                      outlined
                      class="mt-4"
                    />
                  </div>
                  <div v-else-if="accionSeleccionada === 'anular'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Por qué desea anular estos casos?
                    </p>
                    <v-text-field
                      v-model="masivoMotivo"
                      label="Motivo"
                      outlined
                      class="mt-4"
                    />
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="cerrarModalAccionMasiva"
                  >CANCELAR</v-btn
                >
                <v-btn
                  color="#1D3C7F"
                  :disabled="
                    !accionSeleccionada ||
                    (accionSeleccionada === 'cerrar' &&
                      !isObservacionMasivaValida) ||
                    ((accionSeleccionada === 'suspender' ||
                      accionSeleccionada === 'anular') &&
                      !masivoMotivo) ||
                    (accionSeleccionada === 'reasignar' &&
                      !especialistaSeleccionado)
                  "
                  dark
                  @click="confirmarAccionMasiva"
                  >CONFIRMAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>

          <!-- Modal para ver las evidencias del caso -->
          <v-dialog v-model="dialogEvidencias" max-width="900px">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image-multiple</v-icon>
                  Evidencias del caso #{{ idCasoActual }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div v-if="cargandoEvidencias" class="text-center my-5">
                    <v-progress-circular
                      indeterminate
                      color="#294697"
                    ></v-progress-circular>
                    <p>Cargando evidencias...</p>
                  </div>
                  <div v-else-if="!evidencias.length" class="text-center my-5">
                    <v-alert type="info" outlined>
                      No hay evidencias disponibles para este caso.
                    </v-alert>
                  </div>
                  <v-row v-else>
                    <v-col
                      v-for="(evidencia, index) in evidencias"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-card outlined>
                        <template
                          v-if="isImageUrl(evidencia.cc_ruta_evidencia)"
                        >
                          <v-img
                            :src="evidencia.cc_ruta_evidencia"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="
                              verImagenCompleta(evidencia.cc_ruta_evidencia)
                            "
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#294697"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <template v-else>
                          <v-card
                            class="d-flex flex-column align-center justify-center pa-3"
                            style="
                              cursor: pointer;
                              aspect-ratio: 1;
                              height: 100%;
                            "
                            @click="downloadFile(evidencia.cc_ruta_evidencia)"
                          >
                            <v-icon size="80" color="grey darken-1"
                              >mdi-file-document-outline</v-icon
                            >
                            <div
                              class="mt-2 text-caption grey--text text--darken-1 text-center"
                              style="word-break: break-all"
                            >
                              {{ getFileName(evidencia.cc_ruta_evidencia) }}
                            </div>
                          </v-card>
                        </template>
                        <v-card-text class="pa-2">
                          <small class="grey--text">{{
                            formatDate(evidencia.fecha_subida)
                          }}</small>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeEvidencias"
                  >CERRAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para ver una imagen en pantalla completa -->
          <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
            <v-card flat>
              <v-toolbar dark color="#1D3C7F" flat>
                <v-btn icon dark @click="descargarImagen">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-toolbar-title>Evidencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogImagenCompleta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text
                class="pa-0 d-flex justify-center align-center"
                style="height: calc(100vh - 64px); background-color: #000"
              >
                <img
                  :src="imagenSeleccionada"
                  style="max-height: 95vh; max-width: 95vw; object-fit: contain"
                />
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Modal para ver el historial de acciones del caso -->
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorial"
          />
          <v-dialog v-model="dialogAgregarObservacion" max-width="500px">
            <v-card>
              <v-card-title>Agregar Observación</v-card-title>
              <v-card-text>
                <v-textarea
                  class="pt-5"
                  v-model="nuevaObservacion"
                  label="Observación"
                  rows="2"
                ></v-textarea>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="dialogAgregarObservacion = false"
                  >Cancelar</v-btn
                >
                <v-btn color="primary" @click="guardarObservacion"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorialObservaciones"
            :soloObservaciones="true"
          />
        </v-card>
      </v-flex>
    </v-layout>

    <!-- MODAL DEL ASESOR ------------------------------------ -->
    <v-dialog
      class="dialogAsesor"
      v-model="showDialogAsesor"
      persistent
      max-width="400"
    >
      <v-card class="mx-auto" max-width="400" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-overline mb-4">INFO. ASESOR</div>
            <v-list-item-title class="text-h6 mb-2">
              {{ objAsesor.nombre }}
            </v-list-item-title>
            <v-list-item-subtitle class="mb-2 mt-2">
              <v-icon class="mr-2" size="19">mdi-card-account-details</v-icon>
              {{ objAsesor.cedula }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-icon class="mr-2" size="20">mdi-phone</v-icon>
              {{ objAsesor.telefono }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar size="80" color="blue" rounded="50">
            <v-icon size="60" color="white"> mdi-account-tie </v-icon>
          </v-list-item-avatar>
        </v-list-item>
        <v-card-actions>
          <v-btn
            color="primary"
            elevation="2"
            outlined
            raised
            class="ms-auto"
            @click="showDialogAsesor = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /MODAL DEL ASESOR ------------------------------------ -->

    <v-dialog v-model="dialog1" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-clipboard-check-outline</v-icon>
            Asignar caso
          </span>
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container grid-list-md>
            <v-card-text style="font-size: 18px; color: black">
              ¿Está seguro que desea asignarse este caso?
            </v-card-text>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close1">No</v-btn>
          <v-btn color="#1D3C7F" dark @click="save1(idCaso)">Si</v-btn>
        </v-card-actions>
        <!-- <pre>{{editedItem}}</pre>  -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog4" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-clipboard-check-outline</v-icon>
            Asignar caso
          </span>
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container>
            <v-autocomplete
              class="mt-4"
              v-model="value"
              :items="items"
              item-text="nombre"
              item-value="idUsuario"
              filled
              label="Seleccione el usuario"
            ></v-autocomplete>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close4()">No</v-btn>
          <v-btn color="#1D3C7F" dark @click="save4(idCaso)" :disabled="!value"
            >Si</v-btn
          >
        </v-card-actions>
        <!-- <pre>{{editedItem}}</pre>  -->
      </v-card>
    </v-dialog>
    <!-- Dialog que permite visualizar la conversacion -->
    <v-dialog v-model="dialog2" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-message-bulleted</v-icon>
            Conversación</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <div v-for="(chat, index) in chatItem" :key="index">
            <v-card class="mt-3 mx-auto" width="550">
              <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                <p class="indigo--text text--darken-3">
                  <v-icon color="indigo darken-4" class="ml-5 mr-1"
                    >mdi-robot</v-icon
                  >{{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else class="d-flex justify-end">
                <p class="deep-purple--text text--accent-3">
                  <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                    >mdi-face</v-icon
                  >{{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="chat.user == 'NOVA'" class="">
                <p class="grey--text text--darken-1 text-left chat-message">
                  {{ chat.message }}
                </p>
              </v-card-text>
              <v-card-text v-else class="d-flex justify-end">
                <p class="grey--text text--darken-1 text-right chat-message">
                  {{ chat.message }}
                </p>
              </v-card-text>
            </v-card>
          </div>
          <v-divider class="mt-5"></v-divider>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#1D3C7F"
            dark
            @click="verEvidencias(idCasoActual)"
            class="mr-2"
          >
            <v-icon left>mdi-image-multiple</v-icon>
            VER EVIDENCIAS
          </v-btn>
          <v-btn color="#1D3C7F" dark @click="close2">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog5" max-width="800px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-elevator-up</v-icon> Escalar</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md5 class="mr-14 mt-5">
              <v-autocomplete
                color="#294697"
                persistent-hint
                v-model="editedItem.idArea"
                label="Area"
                :items="areas"
                item-value="idArea"
                item-text="area"
                @change="llamarRequerimientos(editedItem.idArea)"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6 class="mt-5">
              <v-autocomplete
                color="#294697"
                persistent-hint
                v-model="editedItem.requerimientos"
                label="Requerimiento"
                :items="requerimientos"
                item-value="cc_id_requerimientos"
                :item-text="
                  (item) =>
                    item.cc_nombre_requerimiento_con_empresa ||
                    item.cc_nombre_requerimiento
                "
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.cc_nombre_requerimiento
                    }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.nombreEmpresa">
                      <strong>{{ item.nombreEmpresa }}</strong>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <span
                    >{{ item.cc_nombre_requerimiento }}
                    <strong v-if="item.nombreEmpresa"
                      >({{ item.nombreEmpresa }})</strong
                    ></span
                  >
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close5">CERRAR</v-btn>
          <v-btn
            color="#1D3C7F"
            style="color: white"
            @click="save5(idCaso)"
            :disabled="!editedItem.idArea || !editedItem.requerimientos"
            >ESCALAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog3" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-folder-remove-outline</v-icon> Cerrar
            caso</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="editedItem3.Observaciones"
                  label="Observaciones"
                ></v-text-field>
                <!-- INICIO componente del modal agregar imagenes o archivos//jempoder -->
                <div
                  id="drop-area"
                  @dragover.prevent
                  @dragenter.prevent
                  @drop.prevent="handleDrop"
                  @paste.prevent="handlePaste"
                >
                  <img
                    :src="previewImage"
                    v-if="previewImage"
                    alt="Vista previa"
                  />
                  <span v-else>
                    Arrastra y suelta o copia y pega imágenes aquí
                  </span>
                </div>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileChange"
                  style="display: none"
                />
                <button @click="openFileInput" class="upload-button">
                  Seleccionar Archivo
                </button>
                <!-- FIN componente del modal agregar imagenes o archivos//jempoder -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="#1D3C7F" @click="close3">CANCELAR</v-btn>
          <v-btn color="#1D3C7F" @click="save3(idCaso)">CERRAR CASO</v-btn>
        </v-card-actions>
        <!-- <pre>{{editedItem}}</pre>  -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog6" max-width="600px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: black">
            <v-icon color="black">mdi-pencil</v-icon>
            Cambiar estado
          </span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mt-5">
              <v-select
                color="#294697"
                v-model="editedItem.estado"
                :items="['SUSPENDIDO', 'ANULADO']"
                label="Selecciona cambio de estado"
                persistent-hint
                outlined
              ></v-select>
              <v-text-field
                v-model="editedItem.observacion"
                label="Observaciones"
                outlined
                class="mt-4"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" @click="close6">CANCELAR</v-btn>
          <v-btn
            color="#1D3C7F"
            @click="guardarEstado"
            :disabled="!editedItem.estado"
            >GUARDAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
import env from "../../env";
import SemaforoTiempo from "./SemaforoTiempo.vue";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";

export default {
  components: {
    SemaforoTiempo,
    CaseHistoryTimeline,
  },
  data() {
    return {
      // Propiedades para el filtro
      selectedFilter: "pendientes",
      showFilterMenu: false,
      filterOptions: [
        { text: "TICKETS", value: "tickets" },
        { text: "PENDIENTES", value: "pendientes" },
        { text: "ASIGNADOS", value: "asignados" },
        { text: "SUSPENDIDOS", value: "suspendidos" },
        { text: "CERRADOS", value: "cerrados" },
      ],

      // 🟢 NUEVO: Filtro específico para Gestión Humana
      filtroGestionHumana: "todos",
      opcionesGestionHumana: [
        { text: "Todos", value: "todos" },
        { text: "Nómina", value: "nomina" },
        { text: "Bienestar", value: "bienestar" },
        { text: "SST", value: "sst" },
        { text: "Capacitación", value: "capacitacion" },
      ],

      // Ids del usuario
      idAreaUsuario: null,
      idEmpresaUsuario: null,

      /////////////////////////////////////////////JEMPODER
      previewImage: null,
      filesToUpload: null,
      /////////////////////////////////////////////JEMPODER
      loadingObtenerCasos: false,
      /////////////////////////////////////////////JEMPODER
      previewImage: null,
      filesToUpload: null,
      /////////////////////////////////////////////JEMPODER
      objAsesor: {
        nombre: "",
        cedula: "",
        telefono: "",
        correo: "",
      },
      showDialogAsesor: false,
      show: false,
      nombre: localStorage.getItem("nombre"),
      idCargo: localStorage.getItem("idCargo"),
      esLider: false, // 🆕 Propiedad para verificar si el usuario es líder
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      casos: [],
      items: [],
      value: null,
      idCaso: null,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      fechaArea: "",
      idCaso: "",
      casoPendienteObj: {},
      headers: [
        {
          text: "ESTADO",
          value: "semaforo",
          align: "center",
          class: "column",
          sortable: false,
          width: "110px",
        },
        {
          text: "ACCIONES",
          value: "action",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ID",
          value: "cc_id_caso",
          align: "center",
          class: "column",
        },
        {
          text: "AREA",
          value: "cc_nombre_area",
          align: "center",
          class: "column",
        },
        {
          text: "IP",
          value: "ip",
          align: "center",
          class: "column",
        },
        {
          text: "NOMBRE PUNTO",
          value: "nombre_punto",
          align: "center",
          class: "column",
        },
        {
          text: "EMPRESA",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
        },
        {
          text: "MUNICIPIO",
          value: "municipio",
          align: "center",
          class: "column",
        },
        {
          text: "PRIORIDAD",
          value: "cc_prioridad_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "FECHA/HORA APERTURA",
          value: "fecha_inicio",
          align: "center",
          class: "column",
        },
        {
          text: "REQUERIMIENTO",
          value: "cc_nombre_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "ESPECIALISTA ASIGNADO",
          value: "nombre_especialista",
          align: "center",
          class: "column",
        },
        {
          text: "INFO. ASESOR",
          value: "cc_id_asesor",
          align: "center",
          class: "column",
        },
      ],
      headers2: [
        {
          text: "USUARIO",
          align: "left",
          value: "user",
          align: "center",
          class: "column",
        },
        {
          text: "MESSAGE",
          align: "left",
          value: "message",
          align: "center",
          class: "column",
        },
      ],
      requerimientos: [],
      areas: [],
      defaultItem: [],
      editedIndex: -1,
      editedItem: {
        Observaciones: "",
        requerimientos: "",
        idArea: "",
        area: "",
      },
      defaultItem3: [],
      editedItem3: {
        Observaciones: "",
      },
      chatItem: [],
      requerimientosInfo: {},
      dialogEvidencias: false,
      dialogImagenCompleta: false,
      evidencias: [],
      cargandoEvidencias: false,
      imagenSeleccionada: "",
      idCasoActual: null,
      dialogHistorial: false,
      diasFestivos: [],
      casosSeleccionados: [],
      dialogConfirmarAsignacionMasiva: false,
      dialogAsignacionMasivaLider: false,
      especialistaSeleccionadoMasivo: null,
      dialogAgregarObservacion: false,
      nuevaObservacion: "",
      casoSeleccionado: null,
      dialogHistorialObservaciones: false,
      // 🆕 Filtro por empresa
      casosOriginales: [],
      filtroEmpresa: "todos",
      opcionesEmpresa: [
        { text: "Todos", value: "todos" },
        { text: "Apostar", value: "apostar" },
        { text: "Facilisimo", value: "facilisimo" },
      ],
      // 🆕 idArea del usuario para filtrar casos por área
      idAreaUsuario: null,
      // 🆕 idEmpresa del usuario para filtrar casos por empresa
      idEmpresaUsuario: null,
      // 🆕 idEmpresa del caso actual para filtrar áreas al escalar
      idEmpresaCaso: null,
      // 🆕 Propiedades para acciones masivas
      dialogAccionMasiva: false,
      accionesMasivas: [
        {
          key: "asignar",
          label: "Asignar seleccionados",
          icon: "mdi-account-multiple-plus",
          color: "orange lighten-2",
          visible: ["pendientes"],
        },
        {
          key: "reasignar",
          label: "Reasignar",
          icon: "mdi-account-switch",
          color: "blue lighten-2",
          visible: ["pendientes"],
        },
        {
          key: "cerrar",
          label: "Cerrar caso",
          icon: "mdi-folder-remove-outline",
          color: "red lighten-2",
          visible: ["pendientes"],
        },
        {
          key: "suspender",
          label: "Suspender caso",
          icon: "mdi-folder-clock-outline",
          color: "green lighten-2",
          visible: ["pendientes"],
        },
        {
          key: "anular",
          label: "Anular caso",
          icon: "mdi-cancel",
          color: "grey lighten-1",
          visible: ["pendientes"],
        },
        {
          key: "desasignar",
          label: "Desasignar caso",
          icon: "mdi-account-remove-outline",
          color: "blue lighten-2",
          visible: ["pendientes"],
        },
      ],
      accionSeleccionada: null,
      masivoObservaciones: "",
      masivoMotivo: "",
      previewImages: [],
      selectedFiles: [],
      mostrarConfirmacionAsignacion: false,
      // Propiedades para reasignación
      especialistasDisponibles: [],
      especialistaSeleccionado: null,
      observacionReasignacion: "",
      cargandoEspecialistas: false,
      observacionesRules: [
        (v) => !!v || "El campo Observaciones es obligatorio",
        (v) => (v && !v.startsWith(" ")) || "No puede iniciar con un espacio",
        (v) =>
          (v && v.trim().length >= 4) || "Debe contener mínimo 4 caracteres",
      ],
    };
  },
  computed: {
    // 🆕 Determinar si mostrar el filtro por empresa (solo para Mesa de Servicios y Sistemas)
    mostrarFiltroEmpresa() {
      // 🆕 Mostrar filtro para usuarios de Mesa de Servicios (área 1) y Sistemas (área 2)
      // Basado en idArea en lugar de idCargo para asegurar que todos los usuarios de estas áreas lo vean
      return this.idAreaUsuario === 1 || this.idAreaUsuario === 2;
    },
    // 🆕 Casos filtrados por empresa Y por área
    casosFiltrados() {
      let casos = this.casos;

      // 🆕 VALIDACIÓN ESPECIAL: Para cargos 15 y 16 (LOGISTICA-MANTENIMIENTO), no filtrar por idAreaUsuario
      // Estos usuarios deben ver casos de áreas 11 y 12 de Apostar
      const esCargoLogisticaMantenimiento =
        this.idCargo == "15" || this.idCargo == "16";

      // 🆕 FILTRAR POR ÁREA PRIMERO
      if (
        this.idAreaUsuario !== null &&
        this.idAreaUsuario !== undefined &&
        !esCargoLogisticaMantenimiento
      ) {
        casos = casos.filter((caso) => {
          const idAreaCaso = caso.cc_id_area_requerimiento
            ? parseInt(caso.cc_id_area_requerimiento)
            : null;

          // Si el usuario es de Mesa de Servicios (área 1), SOLO casos de área 1
          if (this.idAreaUsuario === 1) {
            return idAreaCaso === 1;
          }
          // Si el usuario es de Sistemas (área 2), SOLO casos de área 2
          if (this.idAreaUsuario === 2) {
            return idAreaCaso === 2;
          }
          // Para otras áreas, permitir casos de su área
          return idAreaCaso === this.idAreaUsuario;
        });
      }

      // 🆕 Para cargos 15 y 16, filtrar solo casos de áreas 11 y 12
      if (esCargoLogisticaMantenimiento) {
        const casosAntesFiltro = casos.length;
        casos = casos.filter((caso) => {
          // 🆕 Obtener el área del caso - puede venir directamente o necesitar parseo
          let idAreaCaso = null;
          if (
            caso.cc_id_area_requerimiento !== null &&
            caso.cc_id_area_requerimiento !== undefined
          ) {
            idAreaCaso = parseInt(caso.cc_id_area_requerimiento);
          }

          const idEmpresa = caso.idEmpresa ? parseInt(caso.idEmpresa) : null;
          const idEmpresaUsuario = this.idEmpresaUsuario
            ? parseInt(this.idEmpresaUsuario)
            : null;

          // 🆕 Si el área es null o 0, el backend debería haberla obtenido pero no lo hizo
          // En este caso, si el caso es de la empresa correcta, permitirlo temporalmente para debug
          if (
            (idAreaCaso === null || idAreaCaso === 0) &&
            idEmpresa === idEmpresaUsuario &&
            idEmpresaUsuario !== null
          ) {
            // No excluir todavía - el backend debería haber obtenido el área
            // Pero por ahora, si es de la empresa correcta, incluirlo para ver si el problema es el área
            return false; // Excluir temporalmente para forzar que el backend obtenga el área
          }

          // Solo mostrar casos de áreas 11 o 12 de la misma empresa del usuario
          // Si idEmpresaUsuario es null, no aplicar este filtro (mostrar todos los casos de áreas 11 y 12)
          if (idEmpresaUsuario === null) {
            return idAreaCaso === 11 || idAreaCaso === 12;
          }

          // Validar que sea área 11 o 12 Y de la misma empresa
          return (
            (idAreaCaso === 11 || idAreaCaso === 12) &&
            idEmpresa === idEmpresaUsuario
          );
        });
      }

      // Luego aplicar el filtro por empresa (si está activo)
      if (this.mostrarFiltroEmpresa && this.filtroEmpresa !== "todos") {
        casos = casos.filter((caso) => {
          const idEmpresa = caso.idEmpresa ? parseInt(caso.idEmpresa) : null;
          const nombreEmpresa = caso.nombreEmpresa
            ? caso.nombreEmpresa.toLowerCase()
            : "";

          if (this.filtroEmpresa === "apostar") {
            return idEmpresa === 2 || nombreEmpresa.includes("apostar");
          } else if (this.filtroEmpresa === "facilisimo") {
            return idEmpresa === 1 || nombreEmpresa.includes("facilisimo");
          }

          return true;
        });
      }

      // 🟢 NUEVO: Aplicar filtro de Gestión Humana
      if (this.idAreaUsuario === 3 && this.idEmpresaUsuario === 1 && this.filtroGestionHumana !== "todos") {
        casos = casos.filter(caso => {
          const nombreReq = caso.cc_nombre_requerimiento || "";
          
          switch (this.filtroGestionHumana) {
            case "nomina":
              return nombreReq.toUpperCase().includes("NOMINA") ||
                     nombreReq.toUpperCase().includes("DESPRENDIBLES DE NOMINA") ||
                     nombreReq.toUpperCase().includes("CERTIFICADO LABORAL") || 
                     nombreReq.toUpperCase().includes("CAMBIO DE EPS O FONDO DE PENSION");
            case "bienestar":
              return nombreReq.toUpperCase().includes("BIENESTAR") || 
                     nombreReq.toUpperCase().includes("PROCESOS DISCIPLINARIOS") || 
                     nombreReq.toUpperCase().includes("ACTIVIDADES BIENESTAR SOCIAL") || 
                     nombreReq.toUpperCase().includes("ACTIVIDADES NIÑOS");
            case "sst":
              return nombreReq.toUpperCase().includes("SST") || 
                     nombreReq.toUpperCase().includes("ACCIDENTE DE TRABAJO") || 
                     nombreReq.toUpperCase().includes("INSPECCION DE PUESTO DE TRABAJO") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE BOTIQUIN") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE CITA CON PSICOLOGO") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE CITA MEDICA") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE COMITE CONVIVENCIA LABORAL");
            case "capacitacion":
              return nombreReq.toUpperCase().includes("CAPACITACION") ||
                      nombreReq.toUpperCase().includes("SOLICITUD DE CAPACITACIONES") || 
                      nombreReq.toUpperCase().includes("SOLICITUD REINDUCCION") || 
                      nombreReq.toUpperCase().includes("CREACION DE USUARIOS UNIVERSIDAD CORPORATIVA") || 
                      nombreReq.toUpperCase().includes("ACTIVACION DE USUARIO TREBOL DEL SABER") || 
                      nombreReq.toUpperCase().includes("SOLICITUD DE CARNET") || 
                      nombreReq.toUpperCase().includes("SOLICITUD DE CHALECO") || 
                      nombreReq.toUpperCase().includes("POSTULACION VACANTE");
            default:
              return true;
          }
        });
      }
      
      return casos;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Permisos Aplicación"
        : "Editar Permisos";
    },
    // 🆕 Computed property para determinar si se puede realizar acción masiva
    puedeRealizarAccionMasiva() {
      if (this.casosSeleccionados.length < 2) return false;

      const estadoSeleccionado = this.verificarEstadosSeleccionados();
      return estadoSeleccionado && estadoSeleccionado !== "mixto";
    },
    // 🆕 Computed property para obtener las acciones disponibles según el estado de los casos seleccionados
    accionesDisponiblesSegunEstado() {
      const accionesDisponibles = this.getAccionesDisponibles();
      return this.accionesMasivas.filter((accion) =>
        accionesDisponibles.includes(accion.key),
      );
    },
    isObservacionMasivaValida() {
      const obs = this.masivoObservaciones;
      return obs && !obs.startsWith(" ") && obs.trim().length >= 4;
    },
    // 🆕 Computed property para mostrar el botón "ASIGNAR SELECCIONADOS"
    // Debe aparecer si el usuario es líder O si pertenece a Mesa de Servicios (área 1) o Sistemas (área 2)
    mostrarBotonAsignarMasivo() {
      if (this.esLider) return true;
      if (this.idAreaUsuario === 1 || this.idAreaUsuario === 2) return true;
      return false;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    // 🆕 Watcher para casos seleccionados
    casosSeleccionados: {
      handler(nuevosCasosSeleccionados) {
        if (nuevosCasosSeleccionados.length > 0) {
          const estadoSeleccionado = this.verificarEstadosSeleccionados();
          if (estadoSeleccionado === "mixto") {
            // Si hay estados mixtos, mostrar mensaje y limpiar selección
            this.text =
              "⚠️ No se pueden combinar casos con estados diferentes. Selecciona casos con el mismo estado.";
            this.snackbar = true;
            this.casosSeleccionados = [];
          }
        }
      },
      deep: true,
    },
  },

  async mounted() {
    await this.cargarDiasFestivos();
    await this.cargarEspecialistas();
    await this.obtenerAreas();
    await this.obtenerIdAreaUsuario();
    await this.obtenerIdEmpresaUsuario();
    await this.verificarLider();
    this.obtenerCasos();
    setInterval(() => {
      this.obtenerCasos();
    }, 60000);
  },

  methods: {
    // 🟢 NUEVO: Aplicar filtro de Gestión Humana
    aplicarFiltroGestionHumana() {
      this.$forceUpdate();
    },

    // 🟢 NUEVO: Obtener idArea del usuario
    async obtenerIdAreaUsuario() {
      try {
        const idUsuario = localStorage.getItem("id");
        const response = await axios.get(
          `${env.endpoint}user/infoUsuario?id=${idUsuario}`,
        );
        if (response.data && response.data.idArea) {
          this.idAreaUsuario = parseInt(response.data.idArea);
        }
      } catch (error) {
        console.error("Error obteniendo idArea del usuario:", error);
        const idArea = localStorage.getItem("idArea");
        if (idArea) {
          this.idAreaUsuario = parseInt(idArea);
        }
      }
    },

    // 🟢 NUEVO: Obtener idEmpresa del usuario
    async obtenerIdEmpresaUsuario() {
      try {
        const idUsuario = localStorage.getItem("id");
        const response = await axios.get(
          `${env.endpoint}user/infoUsuario?id=${idUsuario}`,
        );
        if (response.data && response.data.idEmpresa) {
          this.idEmpresaUsuario = parseInt(response.data.idEmpresa);
        }
      } catch (error) {
        console.error("Error obteniendo idEmpresa del usuario:", error);
      }
    },

    // Método para cambiar de vista
    changeFilter() {
      // Emitir evento para que el componente padre maneje la navegación
      this.$emit("change-view", this.selectedFilter);
    },

    // Método para seleccionar opción del filtro en móvil
    selectFilterOption(value) {
      this.selectedFilter = value;
      this.showFilterMenu = false;
      this.$emit("change-view", value);
    },

    // 🆕 Método para aplicar filtro por empresa
    aplicarFiltroEmpresa() {
      // El filtrado se hace automáticamente en el computed casosFiltrados
      // Solo necesitamos forzar la actualización de la vista
      this.$forceUpdate();
    },

    //Inicio metodos para ingresar imagenes jempoder//////////////ed
    handleDrop(event) {
      event.preventDefault();

      if (event.dataTransfer.files.length > 0) {
        this.showPreview(event.dataTransfer.files[0]);
        this.filesToUpload = event.dataTransfer.files;
      }
    },
    handlePaste(event) {
      event.preventDefault();

      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;

      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.showPreview(file);
          this.filesToUpload = [file];
        }
      }
    },
    handleFileChange() {
      const files = this.$refs.fileInput.files;
      if (files.length > 0) {
        this.showPreview(files[0]);
        this.filesToUpload = files;
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    showPreview(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.previewImage = event.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadFiles(idCaso, uploadFiles) {
      if (this.filesToUpload) {
        const formData = new FormData();
        formData.append("file", this.filesToUpload[0]);

        formData.append("cc_id_caso", this.idCaso);

        axios
          .post(`${env.endpointEvidenciasCaso}`, formData)
          .then((response) => {
            // console.log(response.data);
            this.filesToUpload = null;
            this.previewImage = null;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    //Fin Metodos para ingresar imagenes/////////////////////ed

    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },

    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },

    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.getFileName(url));
      // link.setAttribute('target', '_blank'); // Opens in new tab, useful for some file types or if download attribute is not honored
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleAsesor(asesor) {
      this.objAsesor = {
        nombre: asesor.nombre,
        telefono: asesor.celular,
        correo: asesor.correo,
        cedula: asesor.cedula,
      };
      // console.log(this.objAsesor);
      this.showDialogAsesor = true;
    },
    // Metodo para obtener todos lo incidentes pendientes
    async obtenerCasos() {
      this.loadingObtenerCasos = true;
      try {
        // Primero obtenemos los datos de requerimientos para tener los tiempos máximos (dias, horas, minutos)
        const idUsuario = localStorage.getItem("id");
        const resReq = await axios.get(
          `${env.endpoint}callcenter/requerimientostodos?idUsuario=${idUsuario}`,
        );
        this.requerimientosInfo = {};
        resReq.data.forEach((req) => {
          this.requerimientosInfo[req.cc_id_requerimientos] = req;
        });

        let endpointCasos;
        const idCargo = localStorage.getItem("idCargo");
        if (
          idCargo == "3" ||
          idCargo == "4" ||
          idCargo == "15" ||
          idCargo == "16" ||
          idCargo == "17" ||
          idCargo == "20" 
        ) {
          endpointCasos = `${
            env.endpoint
          }callcenter/incidentes_areas_especiales?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        } else {
          endpointCasos = `${
            env.endpoint
          }callcenter/incidentespendientes?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        }

        // Ahora obtenemos los casos pendientes
        const res = await axios.get(endpointCasos);

        // 🆕 FILTRAR: En Pendientes.vue solo deben aparecer casos SIN ASIGNAR
        // Un caso está sin asignar si id_especialista es 0 o null, o nombre_especialista es 'SIN ASIGNAR'
        const casosSinAsignar = res.data.filter((caso) => {
          const idEspecialista = caso.id_especialista
            ? parseInt(caso.id_especialista)
            : 0;
          const nombreEspecialista = caso.nombre_especialista || "";
          return (
            idEspecialista === 0 &&
            (nombreEspecialista === "SIN ASIGNAR" ||
              nombreEspecialista === "" ||
              !nombreEspecialista)
          );
        });

        for (let i = 0; i < casosSinAsignar.length; i++) {
          if (casosSinAsignar[i].cc_prioridad_requerimiento === "1") {
            casosSinAsignar[i].color = "green";
          } else if (casosSinAsignar[i].cc_prioridad_requerimiento === "2") {
            casosSinAsignar[i].color = "orange";
          } else {
            casosSinAsignar[i].color = "red";
          }
          casosSinAsignar[i].cerrados = Number(casosSinAsignar[i].cerrados);
          casosSinAsignar[i].estado_caso = Number(casosSinAsignar[i].cerrados);
        }

        const ids = casosSinAsignar.map((caso) => caso.cc_id_caso);
        let tiempos = [];
        if (ids.length > 0) {
          try {
            const resp = await axios.post(
              `${env.endpoint}callcenter/tiemposRestantes`,
              { ids },
            );
            if (resp.data.estado) {
              tiempos = resp.data.resultados;
            }
          } catch (e) {
            console.error("Error obteniendo tiempos agrupados:", e);
          }
        }

        for (let i = 0; i < casosSinAsignar.length; i++) {
          const tiempo = tiempos.find(
            (t) => t.idCaso === casosSinAsignar[i].cc_id_caso,
          );
          if (tiempo) {
            casosSinAsignar[i].tiempoRestanteBackend = tiempo.tiempo_restante;
            casosSinAsignar[i].tiempo_acumulado = tiempo.tiempo_acumulado || 0;
            casosSinAsignar[i].fecha_suspension =
              tiempo.fecha_suspension || null;
            casosSinAsignar[i].estado_caso = Number(tiempo.estado_caso);
          } else {
            casosSinAsignar[i].estado_caso = Number(
              casosSinAsignar[i].cerrados,
            );
            if (
              casosSinAsignar[i].cerrados === 0 &&
              !casosSinAsignar[i].tiempoRestanteBackend
            ) {
              casosSinAsignar[i].tiempoRestanteBackend = null;
            }
            casosSinAsignar[i].tiempo_acumulado = 0;
            casosSinAsignar[i].fecha_suspension = null;
          }
        }
        casosSinAsignar.sort((a, b) => {
          const fA = a.fecha_inicio || "";
          const fB = b.fecha_inicio || "";
          return fA.localeCompare(fB);
        });
        this.casos = casosSinAsignar;
        this.casosOriginales = casosSinAsignar;
      } catch (e) {
        console.log("error");
      } finally {
        this.loadingObtenerCasos = false;
      }
    },

    async llamarRequerimientos(idArea) {
      const index = this.areas.findIndex(
        (element) => element.idArea === idArea,
      );
      this.editedItem.area = this.areas[index].area;

      try {
        const idUsuario = localStorage.getItem("id");
        const idCaso = this.idCaso || null;

        let url = `${env.endpoint}callcenter/requerimientosarea?idArea=${idArea}&idUsuario=${idUsuario}`;
        if (idCaso) {
          url += `&idCaso=${idCaso}`;
        }

        const response = await axios.get(url);
        this.requerimientos = response.data;
      } catch (error) {
        console.error("Error cargando requerimientos por área:", error);
        this.requerimientos = [];
      }
    },

    escalar(item) {
      this.dialog5 = true;
      this.fechaArea = item.fecha_area;
      this.idCaso = item.cc_id_caso;
      this.casoPendienteObj = item;
      this.idEmpresaCaso = item.idEmpresa ? parseInt(item.idEmpresa) : null;
      this.obtenerAreas();
    },

    asignarCaso(item) {
      axios
        .get(
          `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
        )
        .then((res) => {
          const esLiderValido = res.data.mensaje === "permite";
          const idCargoNum = parseInt(this.idCargo);
          const esCargoLiderMesaServicios =
            idCargoNum === 22 || this.idCargo == "22";
          const esCargoLiderSistemas = idCargoNum === 4 || this.idCargo == "4";
          const esAreaMesaServiciosOSistemas =
            this.idAreaUsuario === 1 || this.idAreaUsuario === 2;

          const esLiderMesaServiciosOSistemas =
            (esCargoLiderMesaServicios || esCargoLiderSistemas) &&
            (esAreaMesaServiciosOSistemas ||
              this.idAreaUsuario === null ||
              this.idAreaUsuario === undefined);

          if (esLiderValido || esLiderMesaServiciosOSistemas) {
            let cargos = [];

            if (
              esCargoLiderMesaServicios &&
              (this.idAreaUsuario === 1 ||
                this.idAreaUsuario === null ||
                this.idAreaUsuario === undefined)
            ) {
              cargos = [21, 22];
            }
            else if (
              esCargoLiderSistemas &&
              (this.idAreaUsuario === 2 ||
                this.idAreaUsuario === null ||
                this.idAreaUsuario === undefined)
            ) {
              cargos = [4];
            }
            else if (esLiderValido) {
              const grupos = {
                123: [123, 35],
                35: [123, 35],
                128: [128, 45],
                45: [128, 45],
              };
              cargos = grupos[this.idCargo] || [this.idCargo];
            }
            else {
              cargos = [this.idCargo];
            }

            axios
              .get(
                `${
                  env.endpoint
                }callcenter/get_especialistas?idCargo=${cargos.join(
                  ",",
                )}&idUsuario=${localStorage.getItem("id")}`,
              )
              .then((res) => {
                this.items = res.data && res.data.length > 0 ? res.data : [];
              })
              .catch((error) => {
                console.error("Error al consultar especialistas:", error);
                this.items = [];
              })
              .finally(() => {
                this.idCaso = item.cc_id_caso;
                this.dialog4 = true;
              });
          } else {
            this.editedIndex = this.casos.indexOf(item);
            this.idCaso = item.cc_id_caso;
            this.dialog1 = true;
          }
        })
        .catch((error) => {
          console.error("Error al validar líder:", error);
          this.editedIndex = this.casos.indexOf(item);
          this.idCaso = item.cc_id_caso;
          this.dialog1 = true;
        });
    },

    async obtenerAreas() {
      try {
        let url = `${env.endpoint}callcenter/areasConRequerimientos`;
        if (
          this.idEmpresaCaso &&
          (this.idEmpresaCaso === 1 || this.idEmpresaCaso === 2)
        ) {
          url += `?idEmpresa=${this.idEmpresaCaso}`;
        }

        const response = await axios.get(url);
        this.areas = response.data.map((area) => ({
          idArea: String(area.cc_id_area),
          area: area.cc_nombre_area,
        }));
      } catch (error) {
        console.error("Error cargando áreas:", error);
        this.areas = [];
      }
    },

    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      const data = JSON.parse(JSON.stringify(item));
      this.chatItem = data.conversacion;
    },

    cerrarCaso(item) {
      this.editedIndex = this.casos.indexOf(item);
      this.idCaso = item.cc_id_caso;
      this.dialog3 = true;
    },

    close1() {
      this.dialog1 = false;
      this.editedIndex = -1;
    },

    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },

    close5() {
      this.dialog5 = false;
      this.editedItem.requerimientos = "";
      this.editedItem.idArea = "";
      this.editedItem.area = "";
      this.idEmpresaCaso = null;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },

    close3() {
      this.dialog3 = false;
      setTimeout(() => {
        this.idCaso = null;
        this.editedIndex = -1;
        this.editedItem3 = [];
      }, 300);
    },

    close4() {
      this.dialog4 = false;
      this.value = null;
      this.idCaso = null;
    },

    close6() {
      this.dialog6 = false;
    },

    save1(idCaso) {
      axios
        .get(
          `${env.endpoint}callcenter/asignar_caso?id=${localStorage.getItem(
            "id",
          )}&caso=${idCaso}`,
        )
        .then((res) => {
          if (
            res.data.estado === true &&
            res.data.mensaje === "caso asignado correctamente"
          ) {
            this.text = "Caso asignado correctamente";
            this.snackbar = true;
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 2,
              idUsuario: localStorage.getItem("id"),
              observaciones: "",
            });
          } else {
            this.text =
              res.data.mensaje ||
              "No se pudo asignar el caso. Intente nuevamente.";
            this.snackbar = true;
          }
        })
        .catch((error) => {
          console.error("Error al asignar caso:", error);
          this.text = "Error al asignar el caso. Intente nuevamente.";
          this.snackbar = true;
        });
      this.close1(),
        setTimeout(() => {
          this.obtenerCasos();
        }, 500);
    },

    save3(idCaso) {
      const observacionesLimpias = this.sanitizeText(
        this.editedItem3.Observaciones,
      );

      const Observaciones = JSON.stringify({
        idEspecialista: localStorage.getItem("id"),
        cerrados: "1",
        oculto: "1",
        Observaciones: observacionesLimpias,
      });

      this.uploadFiles(idCaso, this.filesToUpload);

      axios
        .get(
          `${env.endpoint}callcenter/cerrar_caso?caso=${idCaso}&Observaciones=${Observaciones}`,
        )
        .then((res) => {
          if (res.data.mensaje === "caso cerrado correctamente") {
            this.text = "Caso cerrado correctamente";
            this.snackbar = true;
            this.casos = this.casos.filter((caso) => caso.cc_id_caso != idCaso);
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 3,
              idUsuario: localStorage.getItem("id"),
              observaciones: observacionesLimpias,
            });
          } else {
            this.text = "No tienes permiso para cerrar este caso";
            this.snackbar = true;
          }
        });
      this.close3(),
        setTimeout(() => {
          this.obtenerCasos();
        }, 500);
    },

    save4(idCaso) {
      axios
        .get(
          `${env.endpoint}callcenter/asignar_caso?id=${this.value}&caso=${idCaso}`,
        )
        .then((res) => {
          if (
            res.data.estado === true &&
            res.data.mensaje === "caso asignado correctamente"
          ) {
            this.text = "Caso asignado correctamente";
            this.snackbar = true;
            const nombreAsignador = localStorage.getItem("nombre");
            let nombreAsignado = "";
            const usuarioAsignado = this.items.find(
              (u) => u.idUsuario === this.value,
            );
            if (usuarioAsignado && usuarioAsignado.nombre) {
              nombreAsignado = usuarioAsignado.nombre;
            } else {
              nombreAsignado = this.value;
            }
            const observacion = `se asignó el ticket a especialista ${nombreAsignado}`;
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 2,
              idUsuario: localStorage.getItem("id"),
              observaciones: observacion,
            });
          } else {
            this.text =
              res.data.mensaje ||
              "No se pudo asignar el caso. Intente nuevamente.";
            this.snackbar = true;
          }
        })
        .catch((error) => {
          console.error("Error al asignar caso:", error);
          this.text = "Error al asignar el caso. Intente nuevamente.";
          this.snackbar = true;
        })
        .finally(() => {
          this.close4();
          this.obtenerCasos();
        });
    },

    save5(idCaso) {
      const caso = JSON.stringify({
        requerimiento: this.casoPendienteObj.cc_nombre_requerimiento,
        area: this.casoPendienteObj.cc_nombre_area,
        fechaArea: this.fechaArea,
      });

      const idUsuario = localStorage.getItem('id');

      axios
        .get(
          `${env.endpoint}callcenter/escalarCaso?idRequerimiento=${this.editedItem.requerimientos}&info=${caso}&idCaso=${idCaso}&idUsuario=${idUsuario}`
        )
        .then(() => {
          let nombreArea = "";
          const areaSeleccionada = this.areas.find(
            (a) => String(a.idArea) === String(this.editedItem.idArea),
          );
          if (areaSeleccionada && areaSeleccionada.area) {
            nombreArea = areaSeleccionada.area;
          } else if (this.editedItem.area) {
            nombreArea = this.editedItem.area;
          } else if (this.casoPendienteObj.cc_nombre_area) {
            nombreArea = this.casoPendienteObj.cc_nombre_area;
          } else {
            nombreArea = "No especificada";
          }

          let nombreRequerimiento = "";
          const reqSeleccionado = this.requerimientos.find(
            (r) =>
              String(r.cc_id_requerimientos) ===
              String(this.editedItem.requerimientos),
          );
          if (reqSeleccionado && reqSeleccionado.cc_nombre_requerimiento) {
            nombreRequerimiento = reqSeleccionado.cc_nombre_requerimiento;
          } else if (this.casoPendienteObj.cc_nombre_requerimiento) {
            nombreRequerimiento = this.casoPendienteObj.cc_nombre_requerimiento;
          } else {
            nombreRequerimiento = "No especificado";
          }

          let areaOrigen = "No especificada";
          if (this.casoPendienteObj && this.casoPendienteObj.cc_nombre_area) {
            areaOrigen = this.casoPendienteObj.cc_nombre_area;
          }
          const observaciones = `Caso escalado desde el área de ${areaOrigen} al área de ${nombreArea}`;
          axios
            .post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 5,
              idUsuario: localStorage.getItem("id"),
              observaciones: observaciones,
            })
            .catch((error) => {
              console.error("Error al registrar la acción de escalado:", error);
            });
          swal({
            title: "Caso escalado",
            text: "El caso fue escalado exitosamente",
            icon: "success",
            timer: 4000,
          });
        });
      this.close5();
    },

    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];

      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
        })
        .catch((error) => {
          console.error("Error al cargar evidencias:", error);
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },

    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },

    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },

    descargarImagen() {
      this.downloadFile(this.imagenSeleccionada);
    },

    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },

    cambiarEstado(item) {
      this.editedItem = { ...item };
      this.dialog6 = true;
      this.idCaso = item.cc_id_caso;
    },

    guardarEstado() {
      const observacionLimpia = this.sanitizeText(this.editedItem.observacion);

      const estadosMap = {
        SUSPENDIDO: { estadoNumero: 3, accion: 6 },
        ANULADO: { estadoNumero: 5, accion: 8 },
      };

      const { estadoNumero, accion } = estadosMap[this.editedItem.estado];
      const observacion = encodeURIComponent(observacionLimpia || "");

      const urlEndpoint = `${env.endpoint}callcenter/cambiarEstado?idCaso=${this.idCaso}&cerrados=${estadoNumero}&observacion=${observacion}`;

      axios
        .get(urlEndpoint)
        .then((res) => {
          if (res.data.estado) {
            this.text = "Estado cambiado correctamente";
            axios
              .post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: this.idCaso,
                accion: accion,
                idUsuario: localStorage.getItem("id"),
                observaciones: observacionLimpia || "",
              })
              .catch((error) => {
                console.error(
                  "Error al registrar la acción en el historial:",
                  error,
                );
              });
            const caso = this.casos.find((c) => c.cc_id_caso == this.idCaso);
            if (caso) {
              caso.cerrados = estadoNumero;
              caso.estado_caso = estadoNumero;
            }
            setTimeout(() => {
              if (estadoNumero === 5) {
                this.obtenerCasos();
              }
            }, 500);
          } else {
            this.text = "Este caso no pudo cambiar de estado";
          }
          this.snackbar = true;
          this.close6();
        })
        .catch((error) => {
          this.text = "Error al cambiar estado";
          this.snackbar = true;
          console.error(error);
        });
    },

    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },

    handleCasoVencido({ idCaso, mensaje }) {
      this.text = mensaje;
      this.snackbar = false;
      this.obtenerCasos();
    },

    async actualizarTiempoRestanteCaso(idCaso) {
      try {
        const resp = await axios.get(
          `${env.endpoint}callcenter/tiempoRestante?idCaso=${idCaso}`,
        );
        const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
        if (caso) {
          caso.tiempoRestanteBackend = resp.data.tiempo_restante;
          caso.tiempo_acumulado = resp.data.tiempo_acumulado || 0;
          caso.fecha_suspension = resp.data.fecha_suspension || null;
          if (resp.data.cerrados) {
            caso.cerrados = resp.data.cerrados;
            caso.estado_caso = resp.data.cerrados;
          }
        }
      } catch (e) {
        console.error("Error al actualizar tiempo restante:", e);
        this.obtenerCasos();
      }
    },

    async cargarDiasFestivos() {
      try {
        const anioActual = new Date().getFullYear();
        const anioSiguiente = anioActual + 1;
        const respuestaActual = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioActual}/CO`,
        );
        const respuestaSiguiente = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioSiguiente}/CO`,
        );
        this.diasFestivos = [
          ...respuestaActual.data,
          ...respuestaSiguiente.data,
        ].map((festivo) => ({
          fecha: new Date(festivo.date + "T00:00:00"),
          nombre: festivo.name,
        }));
      } catch (error) {
        this.diasFestivos = [];
      }
    },

    async verificarLider() {
      try {
        const res = await axios.get(
          `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
        );
        this.esLider = res.data.mensaje === "permite";
      } catch (error) {
        console.error("Error al verificar líder:", error);
        this.esLider = false;
      }
    },

    async abrirConfirmacionAsignacionMasiva() {
      try {
        const res = await axios.get(
          `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
        );
        const esLiderValido = res.data.mensaje === "permite";
        const idCargoNum = parseInt(this.idCargo);
        const esCargoLiderMesaServicios =
          idCargoNum === 22 || this.idCargo == "22";
        const esCargoLiderSistemas = idCargoNum === 4 || this.idCargo == "4";
        const esAreaMesaServiciosOSistemas =
          this.idAreaUsuario === 1 || this.idAreaUsuario === 2;

        const esLiderMesaServiciosOSistemas =
          (esCargoLiderMesaServicios || esCargoLiderSistemas) &&
          (esAreaMesaServiciosOSistemas ||
            this.idAreaUsuario === null ||
            this.idAreaUsuario === undefined);

        if (esLiderValido || esLiderMesaServiciosOSistemas) {
          let cargos = [];

          if (
            esCargoLiderMesaServicios &&
            (this.idAreaUsuario === 1 ||
              this.idAreaUsuario === null ||
              this.idAreaUsuario === undefined)
          ) {
            cargos = [21, 22];
          }
          else if (
            esCargoLiderSistemas &&
            (this.idAreaUsuario === 2 ||
              this.idAreaUsuario === null ||
              this.idAreaUsuario === undefined)
          ) {
            cargos = [4];
          }
          else if (esLiderValido) {
            const grupos = {
              123: [123, 35],
              35: [123, 35],
              128: [128, 45],
              45: [128, 45],
            };
            cargos = grupos[this.idCargo] || [this.idCargo];
          }
          else {
            cargos = [this.idCargo];
          }

          const resEspecialistas = await axios.get(
            `${env.endpoint}callcenter/get_especialistas?idCargo=${cargos.join(
              ",",
            )}&idUsuario=${localStorage.getItem("id")}`,
          );
          this.items =
            resEspecialistas.data && resEspecialistas.data.length > 0
              ? resEspecialistas.data
              : [];
          this.dialogAsignacionMasivaLider = true;
        } else {
          this.dialogConfirmarAsignacionMasiva = true;
        }
      } catch (error) {
        console.error("Error al validar líder:", error);
        this.dialogConfirmarAsignacionMasiva = true;
      }
    },

    async confirmarAsignacionMasiva() {
      this.dialogConfirmarAsignacionMasiva = false;
      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const payload = {
          ids,
          accion: "asignar",
          data: { idEspecialista: localStorage.getItem("id") },
        };
        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );
        if (res.data && res.data.resultados) {
          const casosExitosos = res.data.resultados.filter((r) => r.estado);
          const casosFallidos = res.data.resultados.filter((r) => !r.estado);

          let mensaje = "";
          if (casosExitosos.length > 0) {
            mensaje += `${casosExitosos.length} caso(s) asignado(s) correctamente. `;
          }
          if (casosFallidos.length > 0) {
            const idsFallidos = casosFallidos
              .map((r) => `#${r.idCaso}`)
              .join(", ");
            mensaje += `Error al asignar caso(s): ${idsFallidos}. `;
          }

          this.text = mensaje || "No se pudo procesar la asignación";
          this.snackbar = true;

          res.data.resultados.forEach((r) => {
            if (r.estado) {
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: 2,
                idUsuario: localStorage.getItem("id"),
                observaciones: "",
              });
            }
          });

          this.casosSeleccionados = [];
          this.obtenerCasos();
        }
      } catch (error) {
        this.text = "Error al asignar casos";
        this.snackbar = true;
      }
    },

    closeAsignacionMasivaLider() {
      this.dialogAsignacionMasivaLider = false;
      this.especialistaSeleccionadoMasivo = null;
    },

    async confirmarAsignacionMasivaLider() {
      this.dialogAsignacionMasivaLider = false;

      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const payload = {
          ids,
          accion: "asignar",
          data: { idEspecialista: this.especialistaSeleccionadoMasivo },
        };

        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );

        if (res.data && res.data.resultados) {
          const casosExitosos = res.data.resultados.filter((r) => r.estado);
          const casosFallidos = res.data.resultados.filter((r) => !r.estado);

          let nombreEspecialista = "";
          const especialista = this.items.find(
            (u) => u.idUsuario === this.especialistaSeleccionadoMasivo,
          );
          if (especialista && especialista.nombre) {
            nombreEspecialista = especialista.nombre;
          } else {
            nombreEspecialista = this.especialistaSeleccionadoMasivo;
          }

          let mensaje = "";
          if (casosExitosos.length > 0) {
            mensaje += `${casosExitosos.length} caso(s) asignado(s) correctamente a ${nombreEspecialista}. `;
          }
          if (casosFallidos.length > 0) {
            const idsFallidos = casosFallidos
              .map((r) => `#${r.idCaso}`)
              .join(", ");
            mensaje += `Error al asignar caso(s): ${idsFallidos}. `;
          }

          this.text = mensaje || "No se pudo procesar la asignación";
          this.snackbar = true;

          res.data.resultados.forEach((r) => {
            if (r.estado) {
              const observacion = `se asignó el ticket a especialista ${nombreEspecialista}`;
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: 2,
                idUsuario: localStorage.getItem("id"),
                observaciones: observacion,
              });
            }
          });

          this.casosSeleccionados = [];
          this.especialistaSeleccionadoMasivo = null;
          this.obtenerCasos();
        }
      } catch (error) {
        this.text = "Error al asignar casos";
        this.snackbar = true;
        console.error("Error en asignación masiva de líder:", error);
      }
    },

    abrirModalAccionMasiva() {
      this.accionSeleccionada = null;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.mostrarConfirmacionAsignacion = false;
      this.especialistaSeleccionado = null;
      this.observacionReasignacion = "";
      this.dialogAccionMasiva = true;
    },

    cerrarModalAccionMasiva() {
      this.dialogAccionMasiva = false;
      this.accionSeleccionada = null;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.mostrarConfirmacionAsignacion = false;
      this.especialistaSeleccionado = null;
      this.observacionReasignacion = "";
    },

    async seleccionarAccionMasiva(accion) {
      if (accion === "asignar") {
        try {
          const res = await axios.get(
            `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
          );

          if (res.data.mensaje === "permite") {
            const resEspecialistas = await axios.get(
              `${env.endpoint}callcenter/get_especialistas?idCargo=${
                this.idCargo
              }&idUsuario=${localStorage.getItem("id")}`,
            );
            this.items = resEspecialistas.data;
            this.dialogAccionMasiva = false;
            this.dialogAsignacionMasivaLider = true;
            return;
          } else {
            this.esLider = false;
            this.mostrarConfirmacionAsignacion = true;
          }
        } catch (error) {
          console.error("Error al validar líder:", error);
          this.esLider = false;
          this.mostrarConfirmacionAsignacion = true;
        }
      }

      this.accionSeleccionada = accion;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.mostrarConfirmacionAsignacion = false;
    },

    async confirmarAccionMasiva() {
      if (this.accionSeleccionada === "reasignar") {
        if (!this.especialistaSeleccionado) {
          this.text = "Debe seleccionar un especialista para reasignar";
          this.snackbar = true;
          return;
        }

        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const observacionLimpia = this.sanitizeText(
          this.observacionReasignacion,
        );
        const especialista = this.especialistasDisponibles.find(
          (e) => e.idUsuario === this.especialistaSeleccionado,
        );
        const nombreEspecialista = especialista
          ? especialista.nombre
          : this.especialistaSeleccionado;

        try {
          let resultados = [];
          for (const idCaso of ids) {
            try {
              await axios.get(
                `${env.endpoint}callcenter/deshacerasignado?idCaso=${idCaso}`,
              );
              const res = await axios.get(
                `${env.endpoint}callcenter/asignar_caso?id=${this.especialistaSeleccionado}&caso=${idCaso}`,
              );

              if (res.data.mensaje === "caso asignado correctamente") {
                await axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: idCaso,
                  accion: 11,
                  idUsuario: localStorage.getItem("id"),
                  observaciones: `Caso reasignado a ${nombreEspecialista}. ${observacionLimpia}`,
                });
                resultados.push({
                  idCaso,
                  estado: true,
                  mensaje: "Reasignado correctamente",
                });
              } else {
                resultados.push({
                  idCaso,
                  estado: false,
                  mensaje: "Error al reasignar",
                });
              }
            } catch (error) {
              resultados.push({
                idCaso,
                estado: false,
                mensaje: "Error en el proceso",
              });
            }
          }

          const exitosos = resultados.filter((r) => r.estado).length;
          const total = resultados.length;

          if (exitosos === total) {
            this.text = `Todos los casos (${total}) reasignados correctamente a ${nombreEspecialista}`;
          } else {
            this.text = `${exitosos} de ${total} casos reasignados correctamente a ${nombreEspecialista}`;
          }
          this.snackbar = true;
        } catch (error) {
          this.text = "Error en la reasignación masiva";
          this.snackbar = true;
        }

        this.dialogAccionMasiva = false;
        this.casosSeleccionados = [];
        this.especialistaSeleccionado = null;
        this.observacionReasignacion = "";
        this.obtenerCasos();
        return;
      }

      this.dialogAccionMasiva = false;
      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        let payload = {
          ids,
          accion: this.accionSeleccionada,
          data: {},
        };

        if (this.accionSeleccionada === "cerrar") {
          const observacionesLimpias = this.sanitizeText(
            this.masivoObservaciones,
          );
          payload.data = {
            observaciones: observacionesLimpias,
            idEspecialista: localStorage.getItem("id"),
            bandera: 0,
            oculto: 1,
            cerrados: 1,
          };
        } else if (this.accionSeleccionada === "asignar") {
          payload.data = {
            idEspecialista: localStorage.getItem("id"),
          };
        } else if (this.accionSeleccionada === "suspender") {
          const motivoLimpio = this.sanitizeText(this.masivoMotivo);
          payload.data = {
            motivo: motivoLimpio,
            fecha_suspension: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            idUsuario: localStorage.getItem("id"),
          };
        } else if (this.accionSeleccionada === "anular") {
          const motivoLimpio = this.sanitizeText(this.masivoMotivo);
          payload.data = {
            motivo: motivoLimpio,
          };
        }

        try {
          const res = await axios.post(
            `${env.endpoint}callcenter/acciones_masivas`,
            payload,
          );
          if (res.data && res.data.resultados) {
            const casosExitosos = res.data.resultados.filter((r) => r.estado);
            const casosFallidos = res.data.resultados.filter((r) => !r.estado);

            if (this.accionSeleccionada === "asignar") {
              let mensaje = "";
              if (casosExitosos.length > 0) {
                mensaje += `${casosExitosos.length} caso(s) asignado(s) correctamente. `;
              }
              if (casosFallidos.length > 0) {
                const idsFallidos = casosFallidos
                  .map((r) => `#${r.idCaso}`)
                  .join(", ");
                mensaje += `Error al asignar caso(s): ${idsFallidos}. `;
              }
              this.text = mensaje || "No se pudo procesar la asignación";
            } else if (this.accionSeleccionada === "desasignar") {
              let mensaje = "";
              if (casosExitosos.length > 0) {
                mensaje += `${casosExitosos.length} caso(s) desasignado(s) correctamente. `;
              }
              if (casosFallidos.length > 0) {
                const idsFallidos = casosFallidos
                  .map((r) => `#${r.idCaso}`)
                  .join(", ");
                mensaje += `Error al desasignar caso(s): ${idsFallidos}. `;
              }
              this.text = mensaje || "No se pudo procesar la desasignación";
            } else {
              let mensaje = "";
              if (casosExitosos.length > 0) {
                mensaje += `${casosExitosos.length} caso(s) procesado(s) correctamente. `;
              }
              if (casosFallidos.length > 0) {
                const idsFallidos = casosFallidos
                  .map((r) => `#${r.idCaso}`)
                  .join(", ");
                mensaje += `Error en caso(s): ${idsFallidos}. `;
              }
              this.text = mensaje || "No se pudo procesar la acción";
            }
            this.snackbar = true;

            let codigoAccionHistorial = 0;
            if (this.accionSeleccionada === "asignar")
              codigoAccionHistorial = 2;
            if (this.accionSeleccionada === "desasignar")
              codigoAccionHistorial = 9;
            if (this.accionSeleccionada === "cerrar") codigoAccionHistorial = 3;
            if (this.accionSeleccionada === "suspender")
              codigoAccionHistorial = 6;
            if (this.accionSeleccionada === "anular") codigoAccionHistorial = 8;

            const filesToUpload = [...this.selectedFiles];
            res.data.resultados.forEach((r) => {
              if (r.estado) {
                let observacionesParaHistorial = "";
                if (this.accionSeleccionada === "cerrar") {
                  observacionesParaHistorial = this.sanitizeText(
                    this.masivoObservaciones,
                  );
                } else if (this.accionSeleccionada === "asignar") {
                  observacionesParaHistorial = "Caso asignado masivamente";
                } else {
                  observacionesParaHistorial = this.sanitizeText(
                    this.masivoMotivo,
                  );
                }

                axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: r.idCaso,
                  accion: codigoAccionHistorial,
                  idUsuario: localStorage.getItem("id"),
                  observaciones: observacionesParaHistorial,
                });
                if (
                  this.accionSeleccionada === "cerrar" &&
                  filesToUpload.length
                ) {
                  this.uploadFilesMasivo(r.idCaso, filesToUpload);
                }
              }
            });

            if (
              this.accionSeleccionada === "cerrar" ||
              this.accionSeleccionada === "anular" ||
              this.accionSeleccionada === "suspender"
            ) {
              const idsProcesados = res.data.resultados
                .filter((r) => r.estado)
                .map((r) => r.idCaso);
              this.casos = this.casos.filter(
                (caso) => !idsProcesados.includes(caso.cc_id_caso),
              );
            } else if (this.accionSeleccionada === "asignar") {
              res.data.resultados.forEach((r) => {
                if (r.estado) {
                  const caso = this.casos.find((c) => c.cc_id_caso == r.idCaso);
                  if (caso) {
                    caso.nombre_especialista = this.nombre;
                    caso.cerrados = 2;
                    caso.estado_caso = 2;
                  }
                }
              });
            } else if (this.accionSeleccionada === "desasignar") {
              res.data.resultados.forEach((r) => {
                if (r.estado) {
                  const caso = this.casos.find((c) => c.cc_id_caso == r.idCaso);
                  if (caso) {
                    caso.nombre_especialista = "SIN ASIGNAR";
                    caso.cerrados = 0;
                    caso.estado_caso = 0;
                  }
                }
              });
            }

            this.selectedFiles = [];
            this.previewImages = [];
            if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

            this.dialogAccionMasiva = false;
            this.casosSeleccionados = [];

            setTimeout(() => {
              this.obtenerCasos();
            }, 500);
          }
        } catch (error) {
          console.error("Error en acciones masivas:", error);
          this.text = "Error en la acción masiva: " + (error.message || "error desconocido");
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Error al realizar la acción masiva:", error);
        this.text = "Error al realizar la acción masiva";
        this.snackbar = true;
      }
    },

    verificarEstadosSeleccionados() {
      if (this.casosSeleccionados.length === 0) return null;
      const estados = this.casosSeleccionados.map((caso) =>
        this.getEstadoCaso(caso),
      );
      const estadoUnico = estados[0];
      const todosIguales = estados.every((estado) => estado === estadoUnico);
      if (todosIguales) return estadoUnico;
      return "mixto";
    },

    getAccionesDisponibles() {
      const estadoSeleccionado = this.verificarEstadosSeleccionados();
      if (!estadoSeleccionado || estadoSeleccionado === "mixto") return [];
      const accionesPorEstado = {
        pendiente: ["asignar"],
        asignado: ["cerrar", "suspender", "anular", "desasignar", "reasignar"],
        "asignado-otro": ["desasignar"],
      };
      return accionesPorEstado[estadoSeleccionado] || [];
    },

    getEstadoCaso(item) {
      if (
        item.nombre_especialista === "SIN ASIGNAR" ||
        item.nombre_especialista === null
      ) {
        return "pendiente";
      }
      if (item.nombre_especialista === this.nombre) return "asignado";
      if (
        item.nombre_especialista &&
        item.nombre_especialista !== this.nombre
      ) {
        return "asignado-otro";
      }
      return null;
    },

    handleDropMultiple(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.isImageFile(file)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImages.push(e.target.result);
          };
          reader.readAsDataURL(file);
        }
        this.selectedFiles.push(file);
      }
    },

    handlePasteMultiple(event) {
      event.preventDefault();
      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;
      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (this.isImageFile(file)) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.previewImages.push(e.target.result);
            };
            reader.readAsDataURL(file);
          }
          this.selectedFiles.push(file);
        }
      }
    },

    handleFileChangeMultiple() {
      const files = this.$refs.fileInput.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.isImageFile(file)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImages.push(e.target.result);
          };
          reader.readAsDataURL(file);
        }
        this.selectedFiles.push(file);
      }
    },

    isImageFile(file) {
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".webp",
        ".svg",
      ];
      return imageExtensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext),
      );
    },

    uploadFilesMasivo(idCaso, files) {
      if (files && files.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append("evidencias[]", files[i]);
        }
        formData.append("cc_id_caso", idCaso);
        axios
          .post(`${env.endpointEvidenciasCaso}`, formData)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      }
    },

    async cargarEspecialistas() {
      try {
        this.cargandoEspecialistas = true;
        const res = await axios.get(
          `${env.endpoint}callcenter/get_especialistas?idCargo=${
            this.idCargo
          }&idUsuario=${localStorage.getItem("id")}`,
        );
        this.especialistasDisponibles = res.data;
      } catch (error) {
        console.error("Error al cargar especialistas:", error);
        this.especialistasDisponibles = [];
      } finally {
        this.cargandoEspecialistas = false;
      }
    },

    sanitizeText(text) {
      if (!text) return "";
      return (
        text
          .replace(
            /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu,
            "",
          )
          .replace(/[^\w\s\u00C0-\u017F.,;:()\-\[\]]/g, "")
          .replace(/\s+/g, " ")
          .trim()
      );
    },

    abrirAgregarObservacion(item) {
      this.casoSeleccionado = item;
      this.nuevaObservacion = "";
      this.dialogAgregarObservacion = true;
    },

    async guardarObservacion() {
      if (!this.nuevaObservacion.trim()) return;
      await axios.post(`${env.endpoint}historial/registrar_accion`, {
        cc_id_caso: this.casoSeleccionado.cc_id_caso,
        accion: 10,
        idUsuario: localStorage.getItem("id"),
        observaciones: this.nuevaObservacion,
      });
      this.dialogAgregarObservacion = false;
      this.text = "Observación guardada";
      this.snackbar = true;
    },

    verHistorialObservaciones(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorialObservaciones = true;
    },
  },
};
</script>
<style>
.dialogAsesor .div-icon {
  background: blue;
  height: 80px;
  width: 80px;
}
/* Inicio estilos para ingreso de imagens Jempoder*/
#drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

#drop-area:hover {
  background-color: #f0f0f0;
}

#drop-area img {
  max-width: 100%;
  max-height: 200px;
  margin-bottom: 10px;
}

.upload-button {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
}

.upload-button:hover {
  background-color: #45a049;
}

.send-button {
  background-color: #008cba;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
}

.send-button:hover {
  background-color: #0074a8;
}

.send-button:disabled {
  background-color: #d3d3d3;
  cursor: not-allowed;
}
/* FIN estilos para ingreso de imagens Jempoder*/

.asignar-masivo-btn {
  border-radius: 8px;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 8px;
}

.acciones-masivas-btn {
  border-radius: 8px;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 8px;
}

.acciones-masivas-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 16px 0 0 10px;
  justify-content: flex-start;
}

.accion-masiva-opcion {
  min-width: 150px;
  font-weight: bold;
  font-size: 16px;
  border-radius: 8px;
  transition: box-shadow 0.2s;
}

.accion-masiva-opcion--active {
  box-shadow: 0 0 0 3px #3945d0;
  background: #fffbe6 !important;
}

.headline {
  background-color: #1d3c7f;
  color: white;
  padding: 10px 16px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 600;
}

.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}

@media (max-width: 599px) {
  .update-btn {
    min-width: auto !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}

/* Estilos para el botón de filtro en móvil */
.filter-icon-btn {
  color: #1d3c7f !important;
  align-self: center !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.filter-icon-btn:hover {
  background-color: rgba(29, 60, 127, 0.1) !important;
}

/* Asegurar que el botón de filtro esté bien alineado */
@media (max-width: 599px) {
  .filter-icon-btn {
    height: 40px !important;
    width: 40px !important;
    align-self: center !important;
  }

  .filter-container {
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
  }
}

/* Estilos responsive solo para pantallas pequeñas */
@media (max-width: 960px) {
  .v-toolbar .icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .v-toolbar .icon .v-icon {
    transition: all 0.3s ease !important;
  }

  .v-toolbar .usuario {
    font-weight: bold !important;
    transition: all 0.3s ease !important;
    white-space: nowrap !important;
  }
}

/* Responsive para móvil */
@media (max-width: 599px) {
  .v-toolbar .icon {
    min-width: 40px !important;
    max-width: 40px !important;
    height: 40px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 20px !important;
    margin-left: 8px !important;
    margin-top: 0 !important;
  }

  .v-toolbar .usuario {
    font-size: 14px !important;
    margin-left: 8px !important;
  }

  .v-toolbar .update-btn {
    margin-left: 8px !important;
    min-width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}

/* Responsive para pantallas medianas (tablet) */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .update-btn {
    margin-left: 8px !important;
    min-width: auto !important;
    padding: 0 12px !important;
    font-size: 12px !important;
  }

  .v-toolbar .update-btn .v-btn__content {
    padding: 0 8px !important;
  }
}

/* Responsive para tablet */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .icon {
    min-width: 50px !important;
    max-width: 50px !important;
    height: 50px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 24px !important;
    margin-left: 15px !important;
    margin-top: 12px !important;
  }

  .v-toolbar .usuario {
    font-size: 16px !important;
    margin-left: 12px !important;
  }
}

.offset-half {
  max-width: 98%;
  margin: 15px 1.2rem;
}

@media (max-width: 599px) {
  .offset-half {
    max-width: 98%;
    margin: 10px 6vw;
  }
}
</style>
